import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Page from 'components/pages/Base/Page/Page';

const StyledHydratePage = styled(Page)`
  &.HydratePage {
    display: flex;
    flex-direction: column;
    overflow: auto;
    padding: ${props => props.theme.spacing(3)};

    .HydratePage {
      &-row {
        display: grid;
        grid-template-columns: 1fr 1fr auto ${props => props.theme.layout(80)};
        gap: ${props => props.theme.layout('2sp')};
        padding: ${props => props.theme.layout('0.5sp')} 0;

        > .Typography:last-of-type {
          text-align: right;
          font-variant-numeric: tabular-nums;
        }
      }

      &-path {
        color: ${props => props.theme.property('palette.text.secondary')};
      }

      &-failed {
        color: ${props => props.theme.property('palette.error.main')};
      }

      &-total {
        border-top: 1px solid ${props => props.theme.property('palette.divider')};
        margin-top: ${props => props.theme.layout('1sp')};
        padding-top: ${props => props.theme.layout('1sp')};
      }
    }
  }

  ${props => props.theme.breakpoints.down('lg')} {
    &.HydratePage {
      padding: ${props => props.theme.spacing(2)};
    }
  }

  ${ComponentStyles}
`;

StyledHydratePage.propTypes = {
  theme: PropTypes.object
};

export default StyledHydratePage;
